export const type3DMaterial = [

    {
        "title": "Polylatic acid (PLA)", "value": "Polylatic acid (PLA)"
    },
    {
        "title": "Glycol-modified polyethylene terephthalate (PETG)", "value": "Glycol-modified polyethylene terephthalate (PETG)"
    },
    {
        "title": "Other", "value": "Other"
    },
]

export const colorFilament = [
    {
        "title": "Black", "value": "Black"

    },
    {
        "title": "Other", "value": "Other"
    }
]

export const layerHeight = [
    { title: '0.004" | 0.1mm', "value": '0.004" | 0.1mm' },
    { title: '0.006" | 0.15mm', "value": '0.006" | 0.15mm' },
    { title: '0.008" | 0.2mm', "value": '0.008" | 0.2mm' },
    { title: 'Other', "value": 'Other' },
]

export const surfaceFinish = [
    { title: 'Yes', "value": 'Yes' },
    { title: 'No', "value": 'No' },
    
]